// extracted by mini-css-extract-plugin
export default {"root":"OrgsListGear_root__uHXA2","gearCheck":"OrgsListGear_gearCheck__LJmpC","placeHolderShimmer":"OrgsListGear_placeHolderShimmer__f+oDX"};